import React, { useState, useEffect } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from '../apiConfig';

const ProfileManage = () => {
  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;

  const [userData, setUserData] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [copiedGmail, setCopiedGmail] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.baseURL}/api/users/singleUserBalance/${userInfo.user_id}`
        );
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [userInfo.user_id]);

  // Parse device keys: split by comma, trim whitespace, filter empty
  const deviceKeys = userData?.first_name
    ? userData.first_name
        .split(",")
        .map((k) => k.trim())
        .filter(Boolean)
    : [];

  const handleCopyKey = (key, index) => {
    navigator.clipboard.writeText(key).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };

  const handleCopyGmail = () => {
    navigator.clipboard.writeText(userData?.last_name || "").then(() => {
      setCopiedGmail(true);
      setTimeout(() => setCopiedGmail(false), 2000);
    });
  };

  return (
    <>
      <div id="main-wrapper">
        <Navbar />
        <Chatbox />
        <HeaderRight />
        <LeftSidebar />

        <div className="content-body">
          <div className="container-fluid">
            <div className="col-lg-12">

              {/* Login Gmail Card */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4 className="card-title">Gateway Login Details</h4>
                </div>
                <div className="card-body">
                  {userData ? (
                    <div
                      className="d-flex align-items-center justify-content-between p-3 rounded"
                      style={{ background: "#12486A", border: "1px solid #dee2e6" }}
                    >
                      <span className="fw-semibold text-break me-3 text-white" style={{ fontSize: "0.9rem" }}>
                        {userData.last_name || "—"}
                      </span>
                      {userData.last_name && (
                        <button
                          className="btn btn-sm btn-outline-primary flex-shrink-0 text-white"
                          onClick={handleCopyGmail}
                          title="Copy Gmail"
                        >
                          {copiedGmail ? (
                            <>
                              <i className="fa fa-check me-1 bg-success text-white" /> Copied
                            </>
                          ) : (
                            <>
                              <i className="fa fa-copy me-1 bg-success text-white" /> Copy
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  ) : (
                    <p className="text-muted">Loading...</p>
                  )}
                </div>
              </div>

              {/* Device Keys Card */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4 className="card-title">Device Keys</h4>
                </div>
                <div className="card-body">
                  {userData ? (
                    deviceKeys.length > 0 ? (
                      <div className="d-flex flex-column gap-2">
                        {deviceKeys.map((key, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between p-3 rounded"
                            style={{
                              background: "#12486A",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <div>
                              <span
                                className="badge bg-secondary me-2"
                                style={{ fontSize: "0.7rem" }}
                              >
                                Device No # {index + 1}
                              </span>
                              <span
                                className="fw-semibold font-monospace text-break"
                                style={{ fontSize: "0.9rem", color:'white' }}
                              >
                                {key}
                              </span>
                            </div>
                            <button
                              className="btn btn-sm btn-outline-primary flex-shrink-0 ms-3 text-white"
                              onClick={() => handleCopyKey(key, index)}
                              title="Copy Device Key"
                            >
                              {copiedIndex === index ? (
                                <>
                                  <i className="fa fa-check me-1 bg-success text-white" /> Copied
                                </>
                              ) : (
                                <>
                                  <i className="fa fa-copy me-1  bg-success text-white" /> Copy
                                </>
                              )}
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-muted">No device keys found.</p>
                    )
                  ) : (
                    <p className="text-muted">Loading device keys...</p>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ProfileManage;